"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DataTableContext_1 = require("./DataTableContext");
var DataTableProvider = function (_a) {
    var children = _a.children, onSort = _a.onSort, onSelect = _a.onSelect, onSelectAll = _a.onSelectAll, items = _a.items, idExtractor = _a.idExtractor;
    var _b = (0, react_1.useState)([]), sortBy = _b[0], setSortBy = _b[1];
    var _c = (0, react_1.useState)([]), selected = _c[0], setSelected = _c[1];
    var _d = (0, react_1.useState)([]), expanded = _d[0], setExpanded = _d[1];
    var data = (0, react_1.useMemo)(function () { return items; }, [items]);
    var handleSort = (0, react_1.useCallback)(function (name) {
        var sort = __spreadArray([], sortBy, true);
        var item = sort.find(function (c) { return c.name === name; });
        if (!item) {
            item = {
                name: name,
                order: 'desc',
            };
            sort.push(item);
        }
        else {
            item.order = item.order === 'desc' ? 'asc' : 'desc';
        }
        setSortBy(sort);
        onSort === null || onSort === void 0 ? void 0 : onSort(name, item.order);
    }, [onSort, sortBy]);
    var handleAddSortable = (0, react_1.useCallback)(function (name, order) {
        if (order === void 0) { order = 'asc'; }
        var sorted = __spreadArray([], sortBy, true);
        if (!sorted.find(function (s) { return s.name === name; })) {
            sorted.push({ name: name, order: order });
            setSortBy(sorted);
        }
    }, [sortBy]);
    var handleSelect = (0, react_1.useCallback)(function (rowId, value) {
        var found = selected.find(function (s) { return s.rowId === rowId; });
        var finalValues;
        if (found) {
            finalValues = selected.filter(function (s) { return s.rowId !== rowId; });
        }
        else {
            finalValues = __spreadArray(__spreadArray([], selected, true), [{ rowId: rowId, value: value }], false);
        }
        setSelected(finalValues);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(value, !found);
    }, [selected]);
    var handleSelectAll = (0, react_1.useCallback)(function (checked) {
        var updated;
        if (!checked) {
            updated = [];
        }
        else {
            var selectedItems = data === null || data === void 0 ? void 0 : data.map(function (value, index) {
                var rowId = (idExtractor === null || idExtractor === void 0 ? void 0 : idExtractor(value, index)) || index;
                return { rowId: rowId, value: value };
            });
            updated = __spreadArray([], (selectedItems || []), true);
        }
        setSelected(updated);
        onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(updated);
    }, [selected]);
    var handleExpand = (0, react_1.useCallback)(function (rowId) {
        if (expanded.includes(rowId)) {
            setExpanded(expanded.filter(function (e) { return e !== rowId; }));
        }
        else {
            setExpanded(__spreadArray(__spreadArray([], expanded, true), [rowId], false));
        }
    }, [expanded]);
    return ((0, jsx_runtime_1.jsx)(DataTableContext_1.default.Provider, __assign({ value: {
            onSort: handleSort,
            sortBy: sortBy,
            addSortable: handleAddSortable,
            selectedRows: selected,
            onSelect: handleSelect,
            onSelectAll: onSelectAll ? handleSelectAll : undefined,
            onExpand: handleExpand,
            expanded: expanded,
            data: data,
        } }, { children: children })));
};
exports.DataTableProvider = DataTableProvider;
